var StackItemUtils = {

	getInfo: function(request)
	{
		var request_model = request.get("model"),
			request_action = request.get("action"),
			request_data = JSON.parse(request.get("data"));
		switch (request_model){
			case "contact":
				switch (request_action){
					case "add":
						return {
							title: "Ajout d'une fiche",
							description: request_data.firstname + " " + request_data.lastname
						};
					case "edit":
						return {
							title: "Édition d'une fiche",
							description: request_data.firstname + " " + request_data.lastname
						};
				}
			case "invoice":
				switch (request_action){
					case "add":
						return {
							title: "Nouvelle facture",
							description: "Création de la facture"
						};
					case "edit":
						return {
							title: "Édition d'une facture",
							description: "Facture " + request_data.str_id
						};
					case "delete":
						return {
							title: "Suppression d'une facture",
							description: "Facture " + request_data.str_id
						};
					case "publish":
						return {
							title: "Publication d'une facture",
							description: "Facture " + request_data.str_id + " publiée"
						};
					case "unlock":
						return {
							title: "Déverrouillage d'une facture",
							description: "Facture en cours dépubliée"
						};
				}
			case "element":
				switch (request_action){
					case "auto":
						if (request_data.id == undefined){
							return {
								title: "Nouvel élément",
								description: "Création de l'élément"
							};
						} else {
							return {
								title: "Élément de facture",
								description: "Sauvegarde de l'élément"
							};
						}
					case "duplicate":
						return {
							title: "Élément de facture",
							description: "Duplication de l'élément"
						};
					case "order":
						return {
							title: "Ordre des éléments",
							description: "Enregistré avec succès"
						};
					case "delete_file":
						return {
							title: "Élément #" + (request_data.index + 1),
							description: "Fichier supprimé"
						};
				}
				break;
			case "contract":
				switch (request_action){
					case "auto":
						if (request_data.id == undefined){
							return {
								title: "Nouveau contrat",
								description: "Création du contrat " + request_data.str_id
							};
						} else {
							return {
								title: "Contrat #" + request_data.id,
								description: "Sauvegarde du contrat"
							};
						}
					case "get":
						return {
							title: "Contrat #" + request_data.id,
							description: "Chargement du contrat"
						};
					case "delete_file":
						return {
							title: "Contrat " + request_data.str_id,
							description: "Fichier supprimé"
						};
				}
			case "detailsitem":
				switch (request_action){
					case "auto":
						if (request_data.id == undefined){
							return {
								title: "Nouveaux détails",
								description: "Création de l'item"
							};
						} else {
							return {
								title: "Modification des détails",
								description: "Sauvegarde de l'item"
							};
						}
					case "duplicate":
						return {
							title: "Détails de la facture",
							description: "Duplication de l'item"
						};
					case "order":
						return {
							title: "Ordre des items de l'élément",
							description: "Enregistré avec succès"
						};
				}
			case "mailer":
				switch (request_action) {
					case "send-invoice":
						return {
							title: "Facture envoyée",
							description: "Envoi par courriel effectué avec succès"
						};
				}
		}
		return {
			title: "Opération inconnue",
			description: "--"
		}
	}

};

$.fn.StackItem = function(request)
{
	var _item = this;
	_item.request = request
	_item.expire = undefined;
	_item.interface = {
		icon: undefined,
		icon_class: 'icmn-star-full'
	};

	_item.delete = function()
	{
		clearTimeout(_item.expire);
		_item.slideUp("fast", function(){
			_item.remove();
			$.slr.interface.stack.interface.update();
		});
	};

	_item.success = function()
	{
		_item.find("span.pull-right").text("Complété");
		_item.interface.icon.removeClass(_item.interface.icon_class);
		_item.interface.icon_class = 'fa fa-check';
		_item.interface.icon.addClass(_item.interface.icon_class);
		_item.expire = setTimeout(_item.delete, 10000);
	};

	_item.error = function(permanent)
	{
		_item.find(".pull-right").text("Erreur");
		_item.interface.icon.removeClass(_item.interface.icon_class);
		_item.interface.icon_class = 'fa fa-exclamation-triangle';
		_item.interface.icon.addClass(_item.interface.icon_class);
		if (permanent == undefined){
			permanent = true;
		}
		if (!permanent){
			_item.expire = setTimeout(_item.delete, 10000);
		}
	};

	return function()
	{
		var request_info = StackItemUtils.getInfo(request);
		_item.addClass("cat__top-bar__activity__item");
	 	_item.interface.icon = $('<i></i>').addClass('cat__top-bar__activity__icon').addClass(_item.interface.icon_class);
		var text = $('<div></div>').addClass('cat__top-bar__activity__inner'),
			title = $('<div></div>').addClass('cat__top-bar__activity__title'),
			description = $('<div></div>').addClass('cat__top-bar__activity__descr');
		title.append('<span class="pull-right"></span>');
		title.append('<a href="#">' + request_info.title + '</a>');
		description.text(request_info.description);
		text.append(title).append(description);
		_item.append(_item.interface.icon).append(text);
		return _item;
	}();
};

$.fn.Stack = function()
{
	var _sm = this;
	_sm.status = {
		_active : false,
		_empty : true,
		set active(is_active){
			this._active = is_active;
			_sm.interface.setActive(this._active);
		},
		set empty(is_empty){
			this._empty = is_empty;
			_sm.interface.setEmpty(this._empty);
		},
		get active(){ return this._active; },
		get empty(){ return this._empty; },
	};

	_sm.interface =
	{
		icon: _sm.find('#stack-icon'),
		queue: _sm.find('#stack-queue'),
		empty: _sm.find("#stack-empty"),

		setActive: function(active){
			if (active){
				_sm.interface.icon.addClass('fa-circle-o-notch fa-spin').removeClass('fa-server');
			} else {
				_sm.interface.icon.removeClass('fa-circle-o-notch fa-spin').addClass('fa-server');
			}
		},

		setEmpty: function(empty){
			if (empty){
				_sm.interface.empty.slideDown("fast");
			} else {
				_sm.interface.empty.slideUp("fast");
			}
		},

		update: function(){
			if (_sm.find('.cat__top-bar__activity__item:not(#stack-empty)').length === 0){
				_sm.status.empty = true;
			} else {
				_sm.status.empty = false;
			}
		}
	};

	_sm.add = function(queue_item)
	{
		queue_item.hide();
		_sm.interface.queue.append(queue_item.slideDown("fast"));
		_sm.interface.update();
	};

	return function()
	{
		return _sm;
	}();
};
